/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDeliverableInvoiceResource } from './';
import {
    ProjectDeliverableInvoiceResourceFromJSON,
    ProjectDeliverableInvoiceResourceFromJSONTyped,
    ProjectDeliverableInvoiceResourceToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';
import type { ProjectDeliverableResource } from './';
import {
    ProjectDeliverableResourceFromJSON,
    ProjectDeliverableResourceFromJSONTyped,
    ProjectDeliverableResourceToJSON,
} from './';
import type { ProjectDeliverableType } from './';
import {
    ProjectDeliverableTypeFromJSON,
    ProjectDeliverableTypeFromJSONTyped,
    ProjectDeliverableTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectSingleDeliverableResource
 */
export interface ProjectSingleDeliverableResource extends ProjectDeliverableResource {
}

/**
 * Check if a given object implements the ProjectSingleDeliverableResource interface.
 */
export function instanceOfProjectSingleDeliverableResource(value: object): value is ProjectSingleDeliverableResource {
    return true;
}

export function ProjectSingleDeliverableResourceFromJSON(json: any): ProjectSingleDeliverableResource {
    return ProjectSingleDeliverableResourceFromJSONTyped(json, false);
}

export function ProjectSingleDeliverableResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectSingleDeliverableResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverableResourceFromJSONTyped(json, ignoreDiscriminator),
    };
}

export function ProjectSingleDeliverableResourceToJSON(value?: ProjectSingleDeliverableResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverableResourceToJSON(value, true),
    };
}

